import { ReactElement, ChangeEvent } from 'react'
import { Checkbox, Typography, SxProps } from '@mui/material'
import { Box } from '@ui/structure'

export interface CheckboxLabeledProps {
  checked: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  label: string
  disabled?: boolean
  'data-cy'?: string
  sx?: SxProps
}

const CheckboxLabeled = ({
  label,
  checked,
  onChange,
  disabled,
  'data-cy': dataCy,
}: CheckboxLabeledProps): ReactElement => {
  return (
    <Box display="flex" alignItems="center">
      <Checkbox
        checked={checked}
        onChange={onChange}
        sx={{ padding: 0 }}
        disabled={disabled}
        data-cy={dataCy}
      />
      <Typography sx={{ py: 0, px: 1 }}>{label}</Typography>
    </Box>
  )
}

export default CheckboxLabeled
